<template>
  <div id="sign-in" class="signin-container">
    <div class="signin-card">
      <!-- Icon -->
      <div class="signin-icon">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
          <path d="M15 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M10 17L15 12L10 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M15 12H3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <!-- Header -->
      <div class="signin-header">
        <h1 class="signin-title">Welcome back</h1>
        <p class="signin-subtitle">Sign in to your business account</p>
      </div>

      <!-- Form -->
      <SigninForm @signIn="signIn" />

      <!-- Footer -->
      <div class="signin-footer">
        <span class="signin-footer__text">Don't have an account?</span>
        <router-link to="/onboarding/account-type" class="signin-footer__link">
          Create account
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import SigninForm from "@/components/onboarding/forms/SigninForm";
import responseHandler from "@/utils/responseHandler.js";
import api from "@/utils/api.js";
import { removeItem, setItem } from "@/utils/storage.js";

export default {
  name: "SignIn",

  components: {
    SigninForm,
  },

  methods: {
    ...mapActions("loadingModule", ["signinSuccess", "signinLoading"]),
    ...mapActions("organisationModule", ["getOrganisationProfile"]),
    ...mapActions(["showToast", "logout"]),

    async signIn(payload) {
      this.signinLoading(true);
      try {
        const response = await api.loginOrganisation(payload);
        const { data, message, status } = response.data;
        if (status === "success") {
          this.signinSuccess(true);
          this.showToast({
            description: message,
            display: true,
            type: "success",
          });
          removeItem("payload");
          setItem("org_token", data.token);
          if (data.teamMember) {
            setItem("team_member", data.teamMember);
          }
          await this.getOrganisationProfile(data._id);

          this.$router.push({ name: "OverviewDetails"});
          this.signinLoading(false);
        }
      } catch (error) {
        responseHandler.handleError(error);
        this.signinLoading(false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.signin-container {
  width: 560px;
  max-width: 100%;
  padding: 0 16px;

  @media (max-width: 600px) {
    width: 100%;
  }
}

.signin-card {
  background: white;
  border-radius: 16px;
  padding: 48px 56px;
  border: 1px solid #E2E8F0;

  @media (max-width: 480px) {
    padding: 32px 24px;
    border-radius: 12px;
  }
}

.signin-icon {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #EBF2FF 0%, #F0F6FF 100%);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4D84FF;
  margin: 0 auto 24px;
}

.signin-header {
  text-align: center;
  margin-bottom: 32px;
}

.signin-title {
  font-family: 'DM Sans', sans-serif;
  font-size: 32px;
  font-weight: 500;
  color: #0F172A;
  margin: 0 0 8px 0;
  letter-spacing: -0.02em;
}

.signin-subtitle {
  font-family: 'DM Sans', sans-serif;
  font-size: 15px;
  font-weight: 400;
  color: #64748B;
  margin: 0;
}

.signin-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding-top: 8px;

  &__text {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #64748B;
  }

  &__link {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #4D84FF;
    text-decoration: none;
    transition: color 0.15s ease;

    &:hover {
      color: #3B6FE8;
    }
  }
}
</style>
